import type { TranslationDict } from '../en';

const ja: TranslationDict = {
  'header.buy': '購入',
  'header.sell': '売却',
  'spend.label': '支払い金額',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',
  'receive.label': '受取金額',
  'payment.label': '支払い方法',
  'payment.select': '選択',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': 'このペアに利用可能な支払い方法がありません',
  'wallet.label': '受取ウォレットアドレス',
  'wallet.placeholderBuy': '受取アドレスを入力してください',
  'wallet.placeholderSell': '送信アドレスを入力してください',
  'wallet.validating': 'アドレスを検証中...',
  'wallet.invalid': '有効なウォレットアドレスを入力してください',
  'wallet.invalidServer': '無効なウォレットアドレス',
  'cta.buy': '{crypto} を購入',
  'cta.sell': '{crypto} を売却',
  'cta.gettingPrice': '最適な価格を取得中...',
  'cta.processing': '処理中...',
  'footer.poweredBy': 'Powered by ',
  'footer.brand': 'NowRamp',
  'rate.title': 'レート内訳',
  'rate.close': '閉じる',
  'rate.updatesIn': 'レート更新まで 00:{seconds}',
  'rate.noQuote': '見積もりがありません',
  'rate.exchangeRate': '為替レート',
  'rate.processingFee': '処理手数料',
  'rate.networkFee': 'ネットワーク手数料',
  'rate.provider': 'プロバイダー',
  'toast.orderCreated': '注文が作成されました',
  'toast.redirecting': 'チェックアウトにリダイレクト中...',
  'toast.orderFailed': '注文に失敗しました',
  'toast.couldNotCreate': '注文を作成できませんでした',
  'toast.quoteError': '見積もりエラー',
  'toast.noProviders': 'プロバイダーがありません',
  'toast.somethingWrong': '問題が発生しました',
  'error.amountZero': '金額は 0 より大きくする必要があります',
  'error.minAmountFiat': '最低金額は {min} {currency} です',
  'error.minAmountCrypto': '最低金額は {min} {currency} です',
  'error.noProviders': 'この組み合わせで利用可能なプロバイダーがありません',
  'error.currencyUnavailableBuy': 'この通貨は購入注文に対応していません',
  'error.currencyUnavailableSell': 'この通貨は売却注文に対応していません',
  'parity.info': '{receiveAmount} {crypto} が請求されます。{spendAmount} {fiat} までの残額は {partner} アカウントに入金されます',
  'redirect.secureBadge': '安全な支払い',
  'redirect.title': '支払いを続行',
  'redirect.description': '支払いを完了するために {gateway} にリダイレクトされます。',
  'redirect.countdown': '{seconds} 後にリダイレクトします...',
  'redirect.openTab': '新しいタブで ACH を開く',
  'redirect.cancel': 'キャンセル',
  'checkout.noOrder': '注文が見つかりません',
  'checkout.goBack': '戻る',
  'checkout.expired': 'チェックアウトの有効期限切れ',
  'checkout.expiredDesc': 'セッションの有効期限が切れました。もう一度お試しください。',
  'checkout.startOver': 'やり直す',
  'checkout.cancel': 'キャンセル',
  'checkout.loading': 'チェックアウトを読み込み中...',
  'checkout.iframeTitle': 'プロバイダーチェックアウト',
  'checkout.widgetTitle': '支払いチェックアウト',
  'checkout.unknownMethod': '不明なチェックアウト方法',
  'processing.default': '注文を処理中...',
  'processing.pending': '支払いの確認を待っています...',
  'processing.active': '取引を処理中...',
  'processing.generic': '処理中...',
  'processing.checkingStatus': 'ステータスを確認中...',
  'processing.orderId': '注文 ID',
  'processing.provider': 'プロバイダー',
  'processing.amount': '金額',
  'processing.receiving': '受取',
  'processing.network': 'ネットワーク',
  'processing.toAddress': '送信先アドレス',
  'processing.usuallyMinutes': '通常、数分かかります。',
  'processing.safeToClose': 'このページを閉じても問題ありません。完了時にメールでお知らせします。',
  'complete.buyTitle': '購入完了！',
  'complete.sellTitle': '売却完了！',
  'complete.buyDesc': '{crypto} がウォレットに送信されました。',
  'complete.sellDesc': '{fiat} の支払いは処理中です。',
  'complete.amountBuy': '受取金額',
  'complete.amountSell': '売却金額',
  'complete.paidBuy': '支払い金額',
  'complete.paidSell': '出金金額',
  'complete.network': 'ネットワーク',
  'complete.wallet': 'ウォレット',
  'complete.transaction': 'トランザクション',
  'complete.provider': 'プロバイダー',
  'complete.orderId': '注文 ID',
  'complete.completed': '完了',
  'complete.viewExplorer': 'エクスプローラーで表示',
  'complete.done': '完了',
  'errorStep.failed': '支払い失敗',
  'errorStep.cancelled': '注文がキャンセルされました',
  'errorStep.expired': '注文の有効期限切れ',
  'errorStep.refunded': '注文が返金されました',
  'errorStep.unknown': '問題が発生しました',
  'errorStep.failedBuy': '支払いを処理できませんでした。もう一度お試しいただくか、別の支払い方法をご利用ください。',
  'errorStep.failedSell': '売却を処理できませんでした。もう一度お試しください。',
  'errorStep.cancelledBuy': '注文がキャンセルされました。支払いは処理されていません。',
  'errorStep.cancelledSell': '売却がキャンセルされました。暗号資産は転送されていません。',
  'errorStep.expiredBuy': '注文の有効期限が切れました。新しい購入を開始してください。',
  'errorStep.expiredSell': '注文の有効期限が切れました。新しい売却を開始してください。',
  'errorStep.refundedBuy': '支払いが返金されました。5～10 営業日以内にアカウントに反映されます。',
  'errorStep.refundedSell': '暗号資産が返還されました。まもなくウォレットに反映されます。',
  'errorStep.genericDesc': '予期しないエラーが発生しました。もう一度お試しください。',
  'errorStep.orderId': '注文 ID',
  'errorStep.tryAgain': '再試行',
  'errorStep.startOver': 'やり直す',
  'errorStep.return': '戻る',
  'errorStep.needHelp': 'お困りですか？お問い合わせ先：',
  'errorStep.reference': '参照番号：{orderId}',
  'confirm.buyTitle': '購入の確認',
  'confirm.sellTitle': '売却の確認',
  'confirm.loading': '読み込み中...',
  'confirm.provider': 'プロバイダー',
  'confirm.youPay': 'お支払い金額',
  'confirm.youSell': '売却金額',
  'confirm.youReceive': '受取金額',
  'confirm.wallet': 'ウォレット',
  'confirm.network': 'ネットワーク',
  'confirm.refundAddress': '返金アドレス',
  'confirm.parityNote': 'プロバイダーからの請求額が異なる場合があります。{amount} {crypto} までの残額は {partner} アカウントに入金されます。',
  'confirm.processing': '処理中...',
  'confirm.confirmPay': '確認して支払う',
  'confirm.confirmSell': '確認して売却',
  'confirm.payout': '{currency} 出金',
  'modal.selectFiat': '法定通貨を選択',
  'modal.selectCrypto': '暗号資産を選択',
  'modal.choosePayment': '支払い方法を選択',
  'modal.selectCountry': '国を選択してください',
  'modal.selectLanguage': 'Select language',
  'modal.popular': '人気',
  'modal.recommended': 'おすすめ',
  'modal.noCurrencies': '通貨が見つかりません',
  'modal.noPaymentMethods': '支払い方法が見つかりません',
  'modal.noCountries': '国が見つかりません',
  'modal.noLanguages': 'No languages found',
  'settings.location': '場所',
  'settings.darkMode': 'ダークモード',
  'settings.privacy': 'プライバシーポリシー',
  'settings.terms': '利用規約',
  'settings.language': '言語',
  // ─── Additional ───
  'modal.chooseRamp': 'Ramp を選択',
  'modal.bestPrice': '最安値',
  'modal.noQuotes': 'このリクエストに利用可能な見積もりがありません',
  'modal.noProvidersFound': 'プロバイダーが見つかりません',
  'payment.unavailableFor': '{currency} に利用可能な支払い方法がありません',
  'skeleton.poweredBy': 'Powered by NowRamp',
  'error.createOrderFailed': '注文の作成に失敗しました',
  'errorStep.returnToMerchant': 'マーチャントに戻る',
  'confirm.cryptoOnNetwork': '{network} の {crypto}',
  'payment.name.card': 'カード',
  'payment.name.bankTransfer': '銀行振込',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default ja;
